import React from 'react';

// Renders a 2-level information architecture tree from a root + sections.
export const InfoArchitecture = ({ ia }) => {
  if (!ia || !ia.sections) return null;
  return (
    <div data-testid="ia-diagram">
      <div className="flex justify-center">
        <span className="glass-btn px-6 py-2.5 rounded-full text-sm font-heading font-bold text-white">{ia.root}</span>
      </div>
      <div className="flex justify-center">
        <span className="w-px h-7 bg-white/15" />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {ia.sections.map((section, i) => (
          <div key={i} className="glass rounded-2xl p-5">
            <h4 className="font-heading font-bold text-white text-sm mb-3 pb-3 border-b border-white/10">{section.title}</h4>
            <div className="space-y-2.5">
              {section.items.map((item, j) => (
                <div key={j} className="flex items-center gap-2.5 text-sm text-zinc-400">
                  <span className="w-1 h-1 rounded-full bg-zinc-500 shrink-0" />
                  {item}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoArchitecture;
